module.exports = __webpack_public_path__ + "img/lined-logo.da9f9ee6.svg";